export default {
    state: {
        goodStandingUnassigned: [],
        goodStandingUnassignedSearched: [],

        goodStandingUnfinished: [],
        goodStandingUnfinishedSearched: [],
        goodStandingOthersUnfinished: [],
        goodStandingOthersUnfinishedSearched: [],

        goodStandingAssignedToYou: [],
        goodStandingAssignedToYouSearched: [],
        goodStandingAssignedToOthers: [],
        goodStandingAssignedToOthersSearched: [],

        goodStandingApproved: [],
        goodStandingApprovedSearched: [],
        goodStandingAllApproved: [],
        goodStandingAllApprovedSearched: [],

        goodStandingDeclined: [],
        goodStandingDeclinedSearched: [],
        goodStandingAllDeclined: [],
        goodStandingAllDeclinedSearched: [],

        goodStandingPendingPayment: [],
        goodStandingPendingPaymentSearched: [],
        goodStandingOthersPendingPayment: [],
        goodStandingOthersPendingPaymentSearched: [],

        goodStandingDeclinedPayment: [],
        goodStandingDeclinedPaymentSearched: [],
        goodStandingOthersDeclinedPayment: [],
        goodStandingOthersDeclinedPaymentSearched: [],
    
        goodStandingLicensed: [],
        goodStandingLicensedSearched: [],
        goodStandingOthersLicensed: [],
        goodStandingOthersLicensedSearched: [],

        goodStandingAllLicensed: [],
        goodStandingAllLicensedSearched: [],

        goodStandingReApply: [],
        goodStandingReApplySearched: [],
        goodStandingOthersReApply: [],
        goodStandingOthersReApplySearched: [],
        
        
    }
}